var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"cabo-logo-container"},[_c('img',{staticClass:"cabo-logo-img",style:({ width: _vm.size + 'px', height: _vm.size + 'px' }),attrs:{"src":"/favicon.png","alt":"Cabo Party Logo"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }